import type { DevAgentPendingFile } from "@/stores/devAgentStore.types";
import type { UploadResult } from "../devAgentService";

interface BuildOutgoingMessageInput {
  text: string;
  uploadedFiles: UploadResult[];
  pendingFile: DevAgentPendingFile | null;
}

interface BuildOutgoingMessageResult {
  fullText: string;
  displayText?: string;
}

export function buildOutgoingMessage({
  text,
  uploadedFiles,
  pendingFile,
}: BuildOutgoingMessageInput): BuildOutgoingMessageResult {
  if (uploadedFiles.length > 0) {
    const fileContext = uploadedFiles
      .map(
        (file) =>
          `[Uploaded: ${file.filename || file.name} (${file.file_type || "text"}, ${
            file.lines || 0
          } lines)]\n\`\`\`\n${(file.full_content || "").slice(0, 8000)}\n\`\`\``,
      )
      .join("\n\n");

    return {
      fullText: `${fileContext}\n\n${text}`,
      displayText: `${uploadedFiles
        .map((file) => file.filename || file.name)
        .join(", ")} — ${text}`,
    };
  }

  return {
    fullText: text,
    displayText: pendingFile ? `[File: ${pendingFile.name}] ${text}` : undefined,
  };
}
